<template>
  <div class="page-container">
    <h1 class="page-title">{{ $t('about_me') }}</h1>
    <div v-if="loading" class="text-tertiary text-sm">Loading...</div>
    <div v-else class="about-content markdown-body" v-html="renderedContent" />
  </div>
</template>

<script>
import { getAboutSettings } from '../api'
import { marked } from 'marked'
import hljs from 'highlight.js'
import { addCopyButtons } from '../utils/code-copy'

marked.setOptions({
  breaks: true,
  highlight: function(code, lang) {
    if (lang && hljs.getLanguage(lang)) return hljs.highlight(code, { language: lang }).value
    return hljs.highlightAuto(code).value
  }
})

export default {
  name: 'About',
  data() {
    return { content: '', loading: true }
  },
  computed: {
    renderedContent() { return this.content ? marked(this.content) : '' }
  },
  watch: {
    content() {
      this.$nextTick(() => {
        setTimeout(() => {
          addCopyButtons(this.$el.querySelector('.about-content'))
        }, 100)
      })
    }
  },
  mounted() {
    getAboutSettings().then(res => {
      this.content = res.data.data.content || ''
    }).finally(() => { this.loading = false })
  }
}
</script>

<style scoped>
.page-title { font-size: 1.3rem; font-weight: 600; margin-bottom: 20px; }
.about-content { font-size: 1rem; line-height: 1.85; color: var(--text-primary); }
</style>
